export default __webpack_public_path__ + "static/media/propeller_front.6334444d.gif";